import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useContext } from 'react';
const Context = React.createContext(null);
export function FeatureConfigProvider({ featureConfig, children }) {
    return _jsx(Context.Provider, { value: featureConfig, children: children });
}
export function useFeatureConfig() {
    return useContext(Context);
}
